import { useMemo } from 'react';
import useTinymceCopilotCollaborationSession from 'tinymce-copilot/useTinymceCopilotCollaborationSession';
import { CopilotCollaborationContext } from 'tinymce-copilot/context';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function ContextProviderHelper({
  children,
  appKey,
  sessionId,
  contentLanguage,
  // TODO hostUrl,
  // TODO settingsLink,
  customHandleTextReplacement,
  useCustomCollaborationSessionLogic
}) {
  const {
    currentContextRef,
    sendActionFromAppToCopilot,
    sendCollaborationStateChangeFromAppToCopilot,
    commandHandler,
    focusHandler
  } = useTinymceCopilotCollaborationSession(appKey, sessionId, customHandleTextReplacement, useCustomCollaborationSessionLogic);
  const contextValue = useMemo(() => ({
    sendActionFromAppToCopilot,
    sendCollaborationStateChangeFromAppToCopilot,
    currentContextRef,
    commandHandler,
    focusHandler,
    contentLanguage,
    sessionId
  }), [sendActionFromAppToCopilot, sendCollaborationStateChangeFromAppToCopilot, currentContextRef, commandHandler, focusHandler, contentLanguage, sessionId]);
  return /*#__PURE__*/_jsx(CopilotCollaborationContext.Provider, {
    value: contextValue,
    children: children
  });
}
export default function CopilotCollaborationContextProvider({
  appKey,
  children,
  isCopilotCollaborationEnabled,
  sessionId,
  hostUrl,
  contentLanguage,
  settingsLink,
  customHandleTextReplacement,
  useCustomCollaborationSessionLogic
}) {
  if (isCopilotCollaborationEnabled) {
    return /*#__PURE__*/_jsx(ContextProviderHelper, {
      appKey: appKey,
      sessionId: sessionId,
      hostUrl: hostUrl,
      contentLanguage: contentLanguage,
      settingsLink: settingsLink,
      customHandleTextReplacement: customHandleTextReplacement,
      useCustomCollaborationSessionLogic: useCustomCollaborationSessionLogic,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}